var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEpubUploaded = function SvgIcnEpubUploaded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 11.6673V33.334C33.3337 34.218 32.9825 35.0658 32.3573 35.691C31.7322 36.3162 30.8843 36.6673 30.0003 36.6673H10.0003C9.11628 36.6673 8.26843 36.3162 7.64329 35.691C7.01818 35.0658 6.66699 34.218 6.66699 33.334V6.66732C6.66699 5.78327 7.01818 4.93537 7.64329 4.31023C8.26843 3.68512 9.11628 3.33398 10.0003 3.33398H25.0003L33.3337 11.6673Z",
    fill: "#AB85D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 11.6673H33.3333L25 3.33398V10.0007C25 10.4427 25.1757 10.8666 25.4882 11.1791C25.8007 11.4917 26.2247 11.6673 26.6667 11.6673Z",
    fill: "#753BBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9998 27.8008C17.7876 27.8008 17.5841 27.7165 17.4341 27.5665L13.4341 23.5665C13.1217 23.254 13.1217 22.7475 13.4341 22.4351C13.7465 22.1227 14.2531 22.1227 14.5655 22.4351L17.9998 25.8694L25.4341 18.4351C25.7465 18.1227 26.2531 18.1227 26.5655 18.4351C26.8779 18.7475 26.8779 19.254 26.5655 19.5665L18.5655 27.5665C18.4154 27.7165 18.212 27.8008 17.9998 27.8008Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEpubUploaded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_epub_uploaded.3b76192d.svg";
export { ForwardRef as ReactComponent };